import React from "react";
import { Helmet } from "react-helmet-async";

// =============================================================================
// SEOMetatag — 페이지별 메타 태그
//
// (2026-08-13 우진) 3가지 수정:
//   1. canonical 추가. 이전엔 public/index.html 의
//      <link rel="canonical" href="https://thegrowing.co/"> 가 모든 라우트에
//      그대로 남아서, 모든 페이지가 "내 정규 URL 은 루트"라고 선언하고 있었음
//      — 하위 페이지가 색인되지 않던 주된 원인.
//   2. og:site_name 을 상수로 고정. 이전엔 props.title 이 들어가서
//      사이트명 자리에 페이지 제목이 노출됐음.
//   3. ogType prop 추가. 도입사례 상세는 "article", 나머지는 "website".
//
// 정적 HTML(scripts/prerender-cases.js)도 같은 값을 굽는다. 이쪽은 SPA 내부
// 이동 시 탭 제목/메타를 갱신하는 용도.
// =============================================================================

const SITE_NAME = "그로잉세일즈";
const SITE_URL = "https://thegrowing.co";

const MetaTag = ({
  title,
  description,
  keywords,
  imageSrc,
  url = `${SITE_URL}/`,
  ogType = "website",
}) => {
  return (
    <Helmet defer={false}>
      <title>{title}</title>

      <link rel="canonical" href={url} />

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageSrc} />
      <meta property="og:url" content={url} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageSrc} />
    </Helmet>
  );
};

export default MetaTag;
